module.exports = __webpack_public_path__ + "img/1557614102309838850.e8daf0b3.png";